import { render, staticRenderFns } from "./CanceledReservationList.vue?vue&type=template&id=d551f254&scoped=true"
import script from "./CanceledReservationList.vue?vue&type=script&lang=js"
export * from "./CanceledReservationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d551f254",
  null
  
)

export default component.exports